import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag } from "antd";
import { QuestionCircleFilled } from "@ant-design/icons";
import { __ } from "../utils";
const LearnMoreTag = (param)=>{
    let { url, style = undefined, label = __("Learn more") } = param;
    const useStyle = {
        cursor: "pointer",
        ...style
    };
    return /*#__PURE__*/ _jsxs(Tag, {
        style: useStyle,
        onClick: ()=>window.open(url, "_blank"),
        children: [
            /*#__PURE__*/ _jsx(QuestionCircleFilled, {}),
            " ",
            label
        ]
    });
};
export { LearnMoreTag };
